import { useClientPortalAPI, useSubmit } from "@certn/api";
import { Stack } from "@certn/cascadia";
import { Card, Loader, Text, Toggle } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useParams } from "react-router-dom";

export function UserPermissionsTab() {
  const { userId } = useParams();

  const {
    data: permissions,
    isLoading,
    mutate,
  } = useClientPortalAPI(
    `/api/internal/client-portal/users/${userId}/permissions/`
  );
  const { submit: updatePermission, isSubmitting } = useSubmit(
    `/api/internal/client-portal/users/${userId}/permissions/update/`,
    {
      showToastOnError: true,
      onSuccess: () => mutate(),
    }
  );

  const onPermissionToggle = async (permission: string, enabled: boolean) => {
    await updatePermission({ permission, enabled });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Card className={styles.userPermissionsCard}>
      {permissions?.map((permissionRow) => {
        return (
          <Stack gap="space-4" orientation="horizontal" align="start">
            <Stack gap="space-3">
              <Text style="global/heading-medium">{permissionRow.title}</Text>
              <Text style="global/body-secondary" color="text-weak">
                {permissionRow.description}
              </Text>
            </Stack>
            <Toggle
              testID={`permission-toggle-${permissionRow.permission.replaceAll(":", "-")}`}
              id={`permission-toggle-${permissionRow.permission.replaceAll(":", "-")}`}
              aria-label={`toggle ${permissionRow.permission}`}
              isSelected={permissionRow.is_enabled}
              onChange={(enabled) => {
                onPermissionToggle(permissionRow.permission, enabled);
              }}
              isDisabled={isSubmitting}
            />
          </Stack>
        );
      })}
    </Card>
  );
}

const styles = {
  userPermissionsCard: css({
    padding: "var(--space-5)",
    borderRadius: "var(--border-radius-3)",
  }),
};
